import { apiFetch } from "./api";

export interface Email {
  id: string,
  smtp_host: string,
  smtp_port: number,
  smtp_username: string,
  smtp_password: string,
  from_email: string,
  from_name: string,
  use_tls: boolean,
  provider: string
}

export type CreateEmailData = Omit<Email, 'id'>;

export function getEmail() {
  return apiFetch<Email>(`/api/email`);
}

export function createEmail(data: CreateEmailData) {
  return apiFetch<Email>("/api/email", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateEmail(id: string, data: Partial<Email>) {
  return apiFetch<Email>(`/api/email/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}
